import BasePage from "./basePage";

export default class Page4 extends BasePage{
    constructor(info){
        super(info);

        this.ele = info.ele;
        this.pageTl = new TimelineMax({ paused: true, ease: Power2.easeOut });

        super.set();
        this._init();
        this._pageSet();
        this._bindEvent();
    }

    _init(){
        this.video = {
            'list1': new nc.promokit.Player({
                selector: '#video_1',
                videoId: 'om4cmH1Zse8',
                mute: false,
                controls: true,
                coverClick: true
            }),
            'list2': new nc.promokit.Player({
                selector: '#video_2',
                videoId: 'BviOzwdNkMU',
                mute: false,
                controls: true,
                coverClick: true
            })
        };
    }

    _pageSet(){
        this.pageTl
            .fromTo( this.ele.querySelector('.tab-tit'), 1, { y: "110%", autoAlpha: 0 }, { y: "0%", autoAlpha: 1, delay: 0.4, ease: Back.easeOut.config(1.05) })
            .fromTo( this.ele.querySelector('.btn-prev'), 0.5, { y: 60, autoAlpha: 0 }, { y: 0, autoAlpha: 1, ease: Power2.easeOut })
            .fromTo( this.ele.querySelector('.btn-next'), 0.5, { y: 60, autoAlpha: 0 }, { y: 0, autoAlpha: 1, ease: Power2.easeOut }, "-=0.3")

    }

    _tabCtrl(){
        $('.section-4 .tab-tit li:first-child').addClass('on');
    }

    _pageMotion(){
        this.pageTl.restart();
        if( $('.section-4 .tab-tit li').eq(0).hasClass('on') ){
            this.video.list2.pause();
            this.video.list1.seek(0.5);
            this.video.list1.play();
        }
        else{
            this.video.list1.pause();
            this.video.list2.seek(0.5);
            this.video.list2.play();
        }
    }

    _bindEvent(){
        let $t, $box;
        $box = $(this.ele).find('.tab-tit li');

        this.ele.querySelector('.btn-prev').addEventListener('click', this._btnAction.bind(this));

        this.ele.querySelector('.btn-next').addEventListener('click', this._btnAction.bind(this));

        $( this.ele ).find('.tab-tit button').on('click', (event)=>{
            $t = $(event.target);
            $box.removeClass('on');
            $t.closest('li').addClass('on');
            TweenMax.to( $(this.ele).find('.video'), 0.7, { autoAlpha: 0 });
            TweenMax.to( $(this.ele).find('#'+ $t.attr( 'data-key' )), 1, { autoAlpha: 1 });


            if( $t.attr( 'data-key' ) == 'video_1' ){
                this.video.list2.pause();
                this.video.list1.seek(0.5);
                this.video.list1.play();
            }
            else{
                this.video.list1.pause();
                this.video.list2.seek(0.5);
                this.video.list2.play();
            }
        });

        this.ele.addEventListener('onComplete', this._pageMotion.bind(this) );
    }

    _btnAction(e){
        let $box = $(this.ele).find('.tab-tit li');

        if( $( e.currentTarget ).hasClass('btn-next') ){
            if( $box.eq(1).hasClass('on') && $('.section-4 .video').eq(1).is(':visible') ) return;

            $box.removeClass('on');
            $box.eq(1).addClass('on');
            TweenMax.to( $(this.ele).find('.video'), 0.7, { autoAlpha: 0 });
            TweenMax.to( $(this.ele).find('#'+ $( e.currentTarget ).attr( 'data-key' )), 1, { autoAlpha: 1 });

            this.video.list1.pause();
            this.video.list2.seek(0.5);
            this.video.list2.play();
        }
        else{
            if( $box.eq(0).hasClass('on') && $('.section-4 .video').eq(0).is(':visible') ) {
                return;
            }
            else{
                $box.removeClass('on');
                $box.eq(0).addClass('on');
                TweenMax.to( $(this.ele).find('.video'), 0.7, { autoAlpha: 0 });
                TweenMax.to( $(this.ele).find('#'+ $( e.currentTarget ).attr( 'data-key' )), 1, { autoAlpha: 1 });

                this.video.list2.pause();
                this.video.list1.seek(0.5);
                this.video.list1.play();
            }
        }
    }

    show(){
        super.show();
    }
    hide(){
        super.hide();
        setTimeout(()=>{
            this.pageTl.reverse();
            this.video.list1.pause();
            this.video.list2.pause();
        }, 500)
    }
}


// WEBPACK FOOTER //
// ./src/js/mainDeath/page4.js